import { useState } from "react";
import { useSchedulingQuery } from "./useSchedulingQuery";
import { listAllAvailabilityExceptions } from "../../components/api/Scheduling/availabilityExceptions";

export default function useScheduleDateChanges({ organizationRef, scheduleId, rules, enabled, limit = 10 }) {
  const ruleIds = [...new Set(rules.filter(rule => rule.active).map(rule => rule.availabilityRuleId))].sort();
  const scope = JSON.stringify([organizationRef, scheduleId, ruleIds, limit]);
  const [position, setPosition] = useState({ scope: "", page: 0 });
  const query = useSchedulingQuery(["scheduling-availability-exceptions", organizationRef, scheduleId, ruleIds],
    async ({ signal, consistency }) => {
      const results = await Promise.all(ruleIds.map(availabilityRuleId => listAllAvailabilityExceptions({
        organizationRef, availabilityRuleId, active: true, limit: 500, signal, consistency,
      })));
      return results.flat().sort((a, b) => a.localDate.localeCompare(b.localDate) ||
        a.availabilityExceptionId.localeCompare(b.availabilityExceptionId));
    }, { enabled: enabled && !!organizationRef && !!scheduleId && ruleIds.length > 0,
      keepPreviousData: false, staleTime: 30000, cacheTime: 300000, refetchOnWindowFocus: false, retry: false });
  const items = query.data || [];
  const lastPage = Math.max(0, Math.ceil(items.length / limit) - 1);
  const page = Math.min(position.scope === scope ? position.page : 0, lastPage);
  return { ...query, data: items.slice(page * limit, (page + 1) * limit), page,
    hasNext: page < lastPage, hasPrevious: page > 0,
    next: () => { if (!query.isFetching && page < lastPage) setPosition({ scope, page: page + 1 }); },
    previous: () => { if (!query.isFetching && page > 0) setPosition({ scope, page: page - 1 }); },
  };
}
